import { Event  } from './Event';
import { Target } from './Target';
export * from './Event';
export * from './Listener';
export * from './Target';
export let eventsDebugger : {
	readonly onEventTrigger    : (ev : Event<any, any>) => void;
	readonly onEventTriggered  : (ev : Event<any, any>) => void;
	readonly initialDispatcher : typeof Target.prototype.dispatchEvent;
	readonly initialListener   : typeof Target.prototype.addEventListener;
};
export function enableDebugAndStrictMode(
	onEventTrigger   : (ev : Event<any, any>) => void,
	onEventTriggered : (ev : Event<any, any>) => void
) {
	eventsDebugger = {
		onEventTrigger,
		onEventTriggered,
		initialDispatcher : Target.prototype.dispatchEvent,
		initialListener   : Target.prototype.addEventListener
	};
	Target.prototype.dispatchEvent = (
		Target as any
	).prototype.dispatchEventDebugAndStrictMode;
	Target.prototype.addEventListener = (
		Target as any
	).prototype.addEventListenerDebugAndStrictMode;
};
export function disableDebugAndStrictMode() {
	if (eventsDebugger) {
		Target.prototype.dispatchEvent    = eventsDebugger.initialDispatcher;
		Target.prototype.addEventListener = eventsDebugger.initialListener;
	}
	eventsDebugger = <any>null;
};
export type NativeEvent = typeof window.Event;
export type ClonableNativeEvent = (
	{
		prototype : {
			type : string;
			constructor : ClonableNativeEvent;
		};
		new(...args : ConstructorParameters<NativeEvent>) : InstanceType<NativeEvent>;
	} &
	NativeEvent
);
export function cloneNative<TEvent extends ClonableNativeEvent>(from : InstanceType<TEvent>) : InstanceType<TEvent> {
	const Event = <ClonableNativeEvent>from.constructor;
	const clone = new Event(from.type, from);
	return (<InstanceType<TEvent>>clone);
}
